export default __webpack_public_path__ + "static/02_alerts-6178721a83679234ebe82deff44c40c2.png";